/**
 * The CSS custom property that holds a platform's brand colour.
 *
 * Platform ids arrive as `GOOGLE_BUSINESS` (API) or `google_business` /
 * `google-business` (UI), but the token is `--color-google-business`, so a
 * plain `var(--color-${id})` silently resolved to nothing for Google Business.
 * Every CSS consumer goes through here; canvas and email code that needs a
 * hex keeps `PLATFORM_COLORS` from `@unipostudio/shared-types`.
 */
export function platformColorVar(id: string, fallback = 'var(--ink-3)'): string {
  const token = id.trim().toLowerCase().replace(/_/g, '-');
  return token ? `var(--color-${token}, ${fallback})` : fallback;
}

/** The AA text shade for platforms whose brand colour is too light as small text. */
const TEXT_SHADE = new Set(['instagram', 'facebook', 'youtube', 'pinterest', 'whatsapp', 'telegram', 'google-business', 'zetpin']);

/** Colour for a platform's name or label set as text on a light surface. */
export function platformTextColorVar(id: string): string {
  const token = id.trim().toLowerCase().replace(/_/g, '-');
  return TEXT_SHADE.has(token) ? `var(--color-${token}-text)` : platformColorVar(id, 'var(--ink-2)');
}
